<template>

  <svg
    t="1639132134917"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="3989"
    width="64"
    height="64"
  ><path d="M308.224 834.048l166.4-67.584 37.376-14.848 37.376 14.848 166.4 67.584-5.12-184.32-1.024-36.352 23.04-28.672 107.008-133.12L667.648 399.36l-33.28-10.24-19.968-28.672-102.912-148.48-102.912 148.48-19.968 28.672-33.28 10.24L184.32 451.584l107.008 133.12 23.04 28.672-1.024 36.352-5.12 184.32m481.792 104.96l-278.016-112.64-278.016 112.64 8.192-304.128-179.712-223.744 282.624-85.504 166.912-240.64 166.912 240.64 282.624 85.504-179.712 224.256 8.192 303.616z" p-id="3990" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconFavorite',
} as DefineComponent
</script>